// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceCollectionList__container-b071fe {
  overflow: auto;
}

.SpaceCollectionList__create-button-d61c88 {
  width: 100%;
}

.SpaceCollectionList__collection-b61eb2 {
  align-items: center;
  display: flex;
  padding: 8px 24px;
}

.SpaceCollectionList__collection-b61eb2:hover {
  background-color: var(--base-17);
  cursor: pointer;
}

.SpaceCollectionList__avatar-fbf067 {
  margin-inline-end: 12px;
  position: relative;
}

.SpaceCollectionList__name-b05778 {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.SpaceCollectionList__badge-debea9 {
  background-color: var(--brand-primary-40);
  border: 2px solid var(--base-10);
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -6px;
  bottom: -6px;
  width: 24px;
  height: 24px;
}

.SpaceCollectionList__badge-icon-b7ce2a {
  fill: var(--addition-50);
}

.SpaceCollectionList__placeholders-baa65a {
  padding: 8px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/AddToSpaceCollectionPopup/SpaceCollectionList/SpaceCollectionList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yCAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".container {\n  overflow: auto;\n}\n\n.create-button {\n  width: 100%;\n}\n\n.collection {\n  align-items: center;\n  display: flex;\n  padding: 8px 24px;\n}\n\n.collection:hover {\n  background-color: var(--base-17);\n  cursor: pointer;\n}\n\n.avatar {\n  margin-inline-end: 12px;\n  position: relative;\n}\n\n.name {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.badge {\n  background-color: var(--brand-primary-40);\n  border: 2px solid var(--base-10);\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: -6px;\n  bottom: -6px;\n  width: 24px;\n  height: 24px;\n}\n\n.badge-icon {\n  fill: var(--addition-50);\n}\n\n.placeholders {\n  padding: 8px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpaceCollectionList__container-b071fe`,
	"create-button": `SpaceCollectionList__create-button-d61c88`,
	"createButton": `SpaceCollectionList__create-button-d61c88`,
	"collection": `SpaceCollectionList__collection-b61eb2`,
	"avatar": `SpaceCollectionList__avatar-fbf067`,
	"name": `SpaceCollectionList__name-b05778`,
	"badge": `SpaceCollectionList__badge-debea9`,
	"badge-icon": `SpaceCollectionList__badge-icon-b7ce2a`,
	"badgeIcon": `SpaceCollectionList__badge-icon-b7ce2a`,
	"placeholders": `SpaceCollectionList__placeholders-baa65a`
};
module.exports = ___CSS_LOADER_EXPORT___;
